import React, { useEffect, useState } from 'react';
import AppMenu from './AppMenu';
import Friends from './Friends';
import { useAuth } from '../context/AuthContext';
import '../styles/AppMenu.css';

export default function AppShell({ children, hideMenu = false, fullBleed = false }) {
  const { user } = useAuth();
  const shellClass = `app-shell${fullBleed ? ' app-shell--full' : ''}`;
  const contentClass = `app-shell__content${fullBleed ? ' app-shell__content--full' : ''}`;
  const [friendsOpenSignal, setFriendsOpenSignal] = useState(0);

  useEffect(() => {
    const openFriends = () => {
      setFriendsOpenSignal(Date.now());
    };

    window.addEventListener('app:open-friends', openFriends);
    return () => window.removeEventListener('app:open-friends', openFriends);
  }, []);

  return (
    <div className={shellClass}>
      {!hideMenu && <AppMenu />}
      <main className={contentClass}>
        {children}
      </main>
      {!hideMenu && user?.id && (
        <Friends userId={user.id} openSignal={friendsOpenSignal} hideTrigger />
      )}
    </div>
  );
}
